var map = {
	"./bg/strings.json": 1877,
	"./cs/strings.json": 1878,
	"./da/strings.json": 1879,
	"./de/strings.json": 1880,
	"./el/strings.json": 1881,
	"./es-419/strings.json": 1882,
	"./es/strings.json": 1883,
	"./et/strings.json": 1884,
	"./fi/strings.json": 1885,
	"./fr-CA/strings.json": 1886,
	"./fr/strings.json": 1887,
	"./it/strings.json": 1888,
	"./lt/strings.json": 1889,
	"./lv/strings.json": 1890,
	"./nl/strings.json": 1891,
	"./no/strings.json": 1892,
	"./pl/strings.json": 1893,
	"./pseudo/strings.json": 1894,
	"./pt/strings.json": 1895,
	"./ro/strings.json": 1896,
	"./sk/strings.json": 1897,
	"./sl/strings.json": 1898,
	"./sv/strings.json": 1899,
	"./zh-CN/strings.json": 1900,
	"./zh-TW/strings.json": 1901
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1876;